import TyoaikatapahtumaLisatiedot from './TyoaikatapahtumaLisatiedot'

export default TyoaikatapahtumaLisatiedot
